/**
 * The Tags column's sort field. OData cannot order by a collection, so the ticket query asks for it with its own
 * parameter, tagorderby, as custom properties use cporderby - the server sorts by each ticket's alphabetically first
 * live tag (TagOrderExtensions).
 */
export const TAGS_SORT_FIELD = 'Tags';

/** A custom property column's sort field is this, a dot and the property's PropertyId. */
export const CustomPropertiesAnswerJsonKey = 'custompropertiesanswerjson';

const sortParameter = (field: string) => {
  if (field === TAGS_SORT_FIELD) return 'tagorderby';
  // An $orderby sent beside it would win, so a custom property column sends only this.
  if (field.startsWith(`${CustomPropertiesAnswerJsonKey}.`)) return 'cporderby';
  return '$orderby';
};

/** The sort part of a ticket query: `tagorderby=` for Tags, `cporderby=` for a custom property, `$orderby=` for every other column. */
export const ticketSortParam = (field: string, descending: boolean): string =>
  `${sortParameter(field)}=${field} ${descending ? 'desc' : 'asc'}`;
